import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-wedding-blush py-16">
      <div className="container mx-auto px-4 text-center">
        <p className="font-script text-4xl text-wedding-accent mb-4">P & A</p>
        <div className="w-12 h-[1px] bg-wedding-primary mx-auto mb-4"></div>
        <p className="text-sm text-gray-600">February 05, 2026</p>
      </div>
    </footer>
  );
};

export default Footer;
